let IslandsManager = xClass("IslandsManager")

let instance = null
IslandsManager.getInstance = function () {
    let self = this
    if (!instance) {
        instance = IslandsManager.create()
    }
    return instance
}
IslandsManager.prototype.ctor = function () {
    let self = this
    self.topId = 0
    self.canGetReward = false
    self.islands = table()
    self.friends = table()

    this.resIslandMap = {};
    this.mysteryRes = null;
}
IslandsManager.prototype.dataFromLogin = function (islandsInfo) {
    let self = this
    if (islandsInfo) {
        self.topId = islandsInfo.topId
        self.canGetReward = islandsInfo.canGetReward
    }
}
IslandsManager.prototype.canGetIslandReward = function () {
    let self = this
    return self.canGetReward
}
IslandsManager.prototype.loadFromServer = function (onSuccess, onFail, onCancel) {
    let self = this
    let http = GetIslandInfo.new()
    function success(evt) {
        if (evt && evt.data) {
            self.islands = evt.data.islands || []
            self.friends = evt.data.friends || []
            let now = Localhost.timeInSec()
            for (let index = 1, v = self.islands[index]; v; v = self.islands[++index]) {
                v.countdown += now
            }
        }
        onSuccess && onSuccess()
    }
    http.addEventListener(Events.kComplete, success)
    http.addEventListener(Events.kError, function (evt) {
        Toast.make(curryQuickGetErrorText(evt.data), 1, () => {
            onFail && onFail()
        })
    })
    http.addEventListener(Events.kCancel, function () {
        onCancel && onCancel()
    })
    http.load()
}
IslandsManager.prototype.getIslandsConfig = function () {
    return UserManager.getInstance().getIslandsConfig()
}
IslandsManager.prototype.getMaxNormalIslandId = function () {
    let maxLevel = MetaManager.getMaxNormalLevelByLevelArea();
    let serverConfig = UserManager.getInstance().getIslandsConfig()
    let maxid = 1
    for (let index = 1, v = serverConfig[index]; v; v = serverConfig[++index]) {
        if (!UserManager.isSpecialIsland(v) && v.id > maxid && v.minLevel < maxLevel) {
            maxid = v.id
        }
    }
    return maxid
}
IslandsManager.prototype.getAllstarIslandsConfig = function () {
    return UserManager.getInstance().getIslandsConfig()
}

IslandsManager.prototype.getTopIslandConfig = function () {
    return UserManager.getInstance().getTopIslandConfig()
}
IslandsManager.prototype.getTopIslandId = function () {
    return UserManager.getInstance().getTopIslandId()
}
IslandsManager.prototype.canUnlockNewIsland = function () {
    return UserManager.getInstance().canUnlockNewIsland()
}
IslandsManager.prototype.getTargetIslandGetedStarCount = function (id) {
    let self = this
    let config = self.getAllStarIslandConfigById(id)
    let starCount = 0
    for (let index = config.minLevel + 1; index <= config.maxLevel; index++) {
        let score = UserScore.getInstance().getScore(index)
        starCount += score.star
    }
    return starCount
}
IslandsManager.prototype.getTargetIslandNeedStarCount = function (id) {
    let self = this
    let config = self.getIslandsConfigById(id)
    
    return config.star
}
IslandsManager.prototype.getTargetIslandStarCount = function (id) {
    let self = this
    let config = self.getAllStarIslandConfigById(id)
    let allStarCount = 0
    for (let index = config.minLevel + 1; index <= config.maxLevel; index++) {
        let levelDigest = LevelConfigManager.getInstance().getLevelDigest(index)
        let scoreRef = UserScore.getInstance().getScore(index)
        if (levelDigest && scoreRef && scoreRef.star > 0) {
            // allStarCount += Math.min($len(levelDigest.scoreTargets), 3)
            allStarCount += $len(levelDigest.scoreTargets)
        }
    }
    return allStarCount
}
IslandsManager.prototype.isTargetIslandGetNoStar = function (id) {
    let self = this
    let getedCount = self.getTargetIslandGetedStarCount(id)
    return getedCount === 0
}
IslandsManager.prototype.targetIslandNotFullAndNotEmptyStar = function (id) {
    let self = this
    let notEmpty = !self.isTargetIslandGetNoStar(id)
    let notFull  = !self.hasTargetIslandGetFullStar(id)
    return notEmpty && notFull
}

// 当前区域已经打了的关卡都是满星
IslandsManager.prototype.hasTargetIslandGetFullStar = function (id) { 
    let self = this
    let getedCount = self.getTargetIslandGetedStarCount(id)
    let allStarCount = self.getTargetIslandStarCount(id)
    return getedCount >= allStarCount
}
IslandsManager.prototype.getAllStarIslandConfigById = function (id) {
    let self = this
    if (!self.allStarIslandsConfig) {
        self.getAllstarIslandsConfig()
    }
    return self.getIslandsConfigById(id, self.allStarIslandsConfig)
}
IslandsManager.prototype.getIslandsConfigById = function (id, config) {
    let allConfig = config || UserManager.getInstance().getIslandsConfig()
    for (let index = 1, v = allConfig[index]; v; v = allConfig[++index]) {
        const element = v
        if (element.id === id) {
            return element
        }
    }
    return null
}
IslandsManager.prototype.getCurrentIslandsIdByLevel = function () {
    return UserManager.getInstance().getCurrentIslandsIdByLevel()
}
IslandsManager.prototype.getFriends = function () {
    let self = this
    return self.friends
}

/**
 * 获取岛屿资源
 * return {
 *  resList: 资源列表
 *  island: 岛屿图片
 *  fnt:    字体
 *  text: 文本
 *  animClass: 动画
 *  name: 名字
 * 
 *  
 *  
 * }
 */
IslandsManager.prototype.getIslandRes = function (config) {
    if (config == null) {
        if (this.mysteryRes == null) {
            let maxId = this.getMaxNormalIslandId();
            let maxIslandConfig = this.getIslandsConfigById(maxId);
            console.log("maxId", maxId);
            this.mysteryRes = {
                resList: ["island/island_x_cloud.png", "font/island_level.fnt"],
                island: "island/island_x_cloud.png",
                fnt: "font/island_level.fnt",
                text: "第" + (maxIslandConfig.maxLevel + 1) + "-？？？关"
            }
        }
        return this.mysteryRes;
    } else {
        let key = config.id + "_" + config.unlock;
        let res = this.resIslandMap[key];
        if (res == null) {
            if (config.unlock == IslandUnlockType.unlocked) { 
                res = {
                    resList: ["island/" + config.id + ".png", "island/" + config.id + "_name.png"],
                    island: "island/" + config.id + ".png",
                    name: "island/" + config.id + "_name.png",
                }
                if (config.id == 1) {
                    // 第一个岛有泡泡机
                    res.resList.push("cocos/homeAnim_bubblemaker.plist");
                    res["animClass"] = require("clover/scene/component/homescene/homeSceneAnim/BubbleMaker");
                }
            } else {
                res = {
                    resList: ["island/" + config.id + "_cloud.png"],
                    island: "island/" + config.id + "_cloud.png"
                }
            }
            this.resIslandMap[key] = res;
        }
        return res;
    }
}

IslandsManager.prototype.isFullStar = function () {
    let notFullStar = false
    let islandsConfig = IslandsManager.getInstance().getAllstarIslandsConfig()
    for (let index = 1, v = islandsConfig[index]; v; v = islandsConfig[++index]) {
        let island = v
        if (!UserManager.isSpecialIsland(island.id) && !IslandsManager.getInstance().hasTargetIslandGetFullStar(island.id)) {
            notFullStar = true
            break
        }
    }
    return !notFullStar
}


module.exports = IslandsManager